<template>
    <div class="pdf-content">
        <main>
			<div v-for="(vehicle, index) in current.vehicles" :key="'vehicle-'+index" class="container-fluid my-3">
				<div class="row">
					<div class="col-sm-12 col-md-12 col-lg-12">
						<div class="row">
							<div class="col-sm-12 col-md-8 col-lg-8 text-start">
								DeliveryB2B - Plataforma de controle de entregas e recebimentos<br/>
								<b>{{ getDocument(current.document) }} {{ current.name }}</b><br/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4 text-lg-end">
								<b>Emissão:</b> {{ getCurrentDateTime() }}<br/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-12 text-center mt-3">
								<h2><b>RELATÓRIO DE CARGA</b></h2>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-12 col-md-12 col-lg-12">
						<hr class="border border-2 border-black opacity-80"/>
					</div>
				</div>
				<div class="row">
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Carga:</b> {{ current.cargo }}</div>
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Situação:</b> {{ current.finished ? "FECHADA" : "ABERTA" }}</div>
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Entregas:</b> {{ vehicle.total_delivery }}</div>
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Peso:</b> {{ getWeight(vehicle.total_weight) }}</div>
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Embarque:</b> {{ getDate(current.date) }}</div>
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Início:</b> {{ getTime(current.start_time, current.end_time, vehicle.time_constraint) }}</div>
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Fim:</b> {{ getTime(current.end_time, current.start_time, vehicle.time_constraint) }}</div>
					<div class="col-sm-6 col-md-6 col-lg-3"><b>Voltar a origem:</b> {{ vehicle.return_origin ? "SIM" : "NÃO" }}</div>
					<div class="col-sm-12 col-md-12 col-lg-6"><b>Motorista:</b> {{ getDriver(vehicle.driver_document, vehicle.driver_name) }}</div>
					<div class="col-sm-6 col-md-6 col-lg-6"><b>Veículo:</b> {{ vehicle.vehicle_license_plate }} - {{ vehicle.vehicle_brand }}</div>
					<div class="col-sm-6 col-md-6 col-lg-6"><b>Telefone:</b> {{ getPhone(vehicle.driver_phone) }}</div>
					
					<div class="col-sm-12 col-md-12 col-lg-12">
						<hr class="border border-2 border-black opacity-80" />
					</div>

					<section class="col-sm-12 col-md-12 col-lg-12 pdf-item">
						<div v-for="(delivery, index_delivery) in vehicle.deliveries" :key="'delivery-'+index_delivery" class="row">
							<div class="col-sm-12 col-md-2 col-lg-2 border-end">
								<div class="row">
									<div class="col-sm-12 col-md-12 col-lg-12 text-center">
										<b>Entrega Nº</b>
									</div>
									<div class="col-sm-12 col-md-12 col-lg-12 text-center">
										<h3><b>{{ getSequence(delivery.sequence) }}</b></h3>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-10 col-lg-10">
								<div class="row border-bottom">
									<div class="col-sm-12 col-md-6 col-lg-3"><h6><b>Número:</b> {{ delivery.delivery_document_number }}</h6></div>
									<div class="col-sm-12 col-md-3 col-lg-3"><b>Quantidade:</b> {{ delivery.delivery_quantity }}</div>
									<div class="col-sm-12 col-md-3 col-lg-3"><b>Peso:</b> {{ getWeight(delivery.delivery_weight) }}</div>
									<div class="col-sm-12 col-md-3 col-lg-3"><b>Valor:</b> {{ getAmount(delivery.delivery_amount) }}</div>
								</div>
								<div class="row">
									<div class="col-sm-12 col-md-12 col-lg-12"><b>Cliente:</b> {{ getDocument(delivery.customer_document) }} {{ delivery.customer_name }}</div>
									<div class="col-sm-12 col-md-12 col-lg-12"><b>Telefone:</b> {{ getPhone(delivery.customer_phone) }}</div>
									<div class="col-sm-12 col-md-12 col-lg-12"><b>Endereço:</b> {{ getAddress(delivery.postal_code, delivery.street, delivery.number, delivery.complement, delivery.neighborhood, delivery.city, delivery.uf) }}</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-12">
								<table class="table table-sm table-striped my-3">
									<thead>
										<tr>
											<th>ITEM</th>
											<th>CÓDIGO</th>
											<th>PRODUTO</th>
											<th>QUANTIDADE</th>
											<th>UNIDADE</th>
											<th>VALOR</th>
										</tr>
									</thead>
									<tbody class="table-group-divider">
										<tr v-for="(item, index_item) in delivery.itens" :key="'item-'+index_item">
											<td>{{ index_item + 1 }}</td>
											<td>{{ item.code }}</td>
											<td>{{ item.description }}</td>
											<td>{{ item.quantity }}</td>
											<td>{{ item.unit }}</td>
											<td>{{ getAmount(item.amount) }}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-12">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-return-right" viewBox="0 0 16 16">
									<path fill-rule="evenodd" d="M1.5 1.5A.5.5 0 0 0 1 2v4.8a2.5 2.5 0 0 0 2.5 2.5h9.793l-3.347 3.346a.5.5 0 0 0 .708.708l4.2-4.2a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 8.3H3.5A1.5 1.5 0 0 1 2 6.8V2a.5.5 0 0 0-.5-.5z"/>
								</svg> 
								<i><b>Obs.: {{ delivery.observation ? delivery.observation : "Sem observações" }}</b></i>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-12">
								<hr class="border-3 border-dashed opacity-80"/>
							</div>
						</div>
					</section>
				</div>
				<div class="row">
					<div class="col-12 my-3">
						<p class="text-center mb-0"><small><b>Emitido em {{ getCurrentDateTime() }}</b></small></p>
						<p class="text-center mb-0"><a class="link-dark text-decoration-none" :href="root_url_painel" target="_blank"><small><b>DeliveryB2B.com.br</b></small></a></p>
					</div>
				</div>
				<div v-if="(index + 1) != current.vehicles.length" class="html2pdf__page-break"></div>
			</div>
		</main>
    </div>
</template>

<script>
export default {
    name: "RoutingPdfContent",

    components: {
    },
    
    props: {
        current: {
            type: Object,
            require: true,
        },
    },

	data: function() {
		return{
			root_url_painel: this.$api.config.B2B_ROOT_PAINEL,
		}
	},
    
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => { this.$emit("domRendered"); }, 1000);
        });
    },

    methods: {
		getAddress: function(postal_code, street, number, complement, neighborhood, city, uf) {
            return postal_code.replace(/^(\d{5})(\d{3})/, "$1-$2") + ", " + street + ", " + number + (complement ? "(" + complement + ")" : "") + " - " + neighborhood + ", " + city + " - " + uf;
        },

		getAmount: function(money) {
			if (money) {
				let moneyAux = ("" + money).split(".");
				if(moneyAux.length > 1) {
					if (moneyAux[1].length > 1){
						return "R$ " + moneyAux[0] + "," + moneyAux[1];
					} else {
						return "R$ " + moneyAux[0] + "," + moneyAux[1] + "0";    
					}
				} else {
					return "R$ " + moneyAux[0] + ",00";
				}
			} else {
				return "R$ 0,00";
			}
		},

		getCargo: function(cargo) {
            if (cargo) return cargo;
            return "Não definida";
        },

		getCurrentDateTime: function() {
            let date_time = new Date();
            
            let date = this.formattedNumber(date_time.getDate());
            let month = this.formattedNumber(date_time.getMonth() + 1);
            let hours = this.formattedNumber(date_time.getHours());
            let minutes = this.formattedNumber(date_time.getMinutes());
            
            return date + "/" + month + "/" + date_time.getFullYear() + " às " + hours + ":" + minutes;
        },

		getDate: function(value) {
            if (value) return value.split("-").reverse().join("/");
            else return "Não definida";
        },

        getDocument: function(value) {
            if (value) {
                if (value.length == 14) return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
                else if (value.length == 11) return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
				else return "Não definido";
            }
            else return "Não definido";
        },

		getDriver: function(document, name) {
            if (document && name) {
				let document_aux = this.getDocument(document);
				return document_aux + " - " + name;
			}
            else return "___________________________________________________";
        },

        getLicensePlate: function(license_plate) {
            if (license_plate) return license_plate;
            return "Não definido";
        },

		/**
         * Retorna o telefone formatado
         * @param {String} phone telephone
         */
		getPhone: function(phone) {
			if (phone) {
				if (phone.length == 8) {
					return phone.replace(/^(\d{4})(\d{4})/, "$1-$2");
				} else if (phone.length == 9) {
					return phone.replace(/^(\d{5})(\d{4})/, "$1-$2");
				} else if (phone.length == 10) {
					return phone.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
				} else if (phone.length == 11) {
					if (phone[0] == "0") {
						return phone.replace(/^(\d{1})(\d{2})(\d{4})(\d{4})/, "$1 ($2) $3-$4");
					} else {
						return phone.replace(/^(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
					}
				} else if (phone.length == 13) {
					return phone.replace(/^(\d{2})(\d{2})(\d{5})(\d{4})/, "+$1 ($2) $3-$4");
				}
			} else {
				return "____________________________________________________";
			}
		},

		getSequence: function(sequence) {
			sequence = parseInt(sequence);
			return (sequence > 10) ? sequence : "0" + sequence;
		},

        getTime: function(time1, time2, constraint) {
			if ((time1 && time2) && (time1 != time2) && constraint) {
				let time_aux = time1.split(":");
				return time_aux[0] + ":" + time_aux[1];
			} else return "______________________";
        },
        

        getWeight: function(weight) {
            let weightFormated = "";
			
            if(weight < 1000)
                weightFormated = weight + " kg";
            else
                weightFormated = (weight / 1000).toFixed(2) + " t";
            
            return weightFormated.replace(".", ",");
        },

		formattedNumber: function(value) {
            return value < 10 ? "0" + value : value;
        },
    },
}
</script>

<style lang="css" scoped src="../../../node_modules/bootstrap/dist/css/bootstrap.css" />
<style lang="css" scoped>
.container-fluid {
	font-size: .80rem !important;
	line-height: 20px;
}

hr {
	border: none !important;
	border-top: 2px solid #dee2e6 !important;
}

.border {
	border-top: 1px solid #dee2e6 !important;
}

.border-2 {
	border-top-width: 2px !important;
}

.border-3 {
	border-top-width: 3px !important;
}

.border-black {
	border-top-color: #000 !important;
}

.border-dashed {
	border-top-style: dashed !important;
}

.opacity-80 {
	opacity: .8 !important;
}

.opacity-100 {
	opacity: 1 !important;
}

.border-bottom {
	border-bottom: 1px solid #dee2e6 !important;
}

.border-end {
	border-right: 1px solid #dee2e6 !important;
}

thead > tr {
	border-bottom: 1px solid #aaa !important;
}

tbody > tr {
	border-bottom: 1px solid #dee2e6 !important;
}
</style>